import { Component } from 'react';
import { DeleteButton } from 'sharedComponents/Buttons/DeleteButton';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';

import moment from 'moment';
import { taskStatus } from 'utils/enums';
import auth from 'utils/auth';

import CompleteIcon from 'assets/icons/TaskIcons/green-circle-checkmark.svg';
import IncompleteIcon from 'assets/icons/TaskIcons/incomplete-circle.svg';
import OverdueIcon from 'assets/icons/TaskIcons/overdue-red-circle.svg';
import { ATSCandidateTaskListTestIds } from 'data-testids/ATS.ts';

export default class CandidateTasksRow extends Component {
  static propTypes = {
    task: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    updateCandidateTask: PropTypes.func.isRequired,
  };

  renderAssignedUsers = (task) => {
    const assigned_users = task.universal_task.assigned_users;
    if (!assigned_users || assigned_users.length === 0) {
      return null;
    }

    return (
      <span>
        by {assigned_users[0]}
        {assigned_users.length > 1 && (
          <span>
            <span data-tip data-for={`assigned-users-${task.id}`}>
              &nbsp;and {assigned_users.length - 1} more
            </span>
            <ReactTooltip id={`assigned-users-${task.id}`} effect="solid">
              {assigned_users.slice(1).join(', ')}
            </ReactTooltip>
          </span>
        )}
      </span>
    );
  };

  renderCompletedBy = (task) => {
    let user = auth.getUser();
    return (
      <span>
        &nbsp;(completed by{' '}
        {task.universal_task.candidate_assigned ? 'Candidate' : task.completed_by} on{' '}
        {moment(task.completed_by_date).format('M/D/YYYY')})
      </span>
    );
  };

  canDeleteIncompleteTask = (task) => {
    const isIncompleteTask = task.status === taskStatus.incomplete;
    const isCompletedTask = task.status === taskStatus.complete;
    const userHasDeletePermission = auth.isDistrictAdmin();

    return (userHasDeletePermission && isIncompleteTask) || isCompletedTask;
  };

  handleDelete = () => {
    this.props.updateCandidateTask(this.props.task, 'delete');
  };

  render() {
    let { task } = this.props;
    return (
      <div className="task-row" data-testid={ATSCandidateTaskListTestIds.FULL_PROFILE_TASK_ROW}>
        <div className="flex">
          <img
            className="mr1 pointer"
            style={{
              height: '21px',
              width: '20px',
            }}
            src={
              task.status === taskStatus.complete
                ? CompleteIcon
                : moment(Date.now()).isAfter(task.due_date)
                  ? OverdueIcon
                  : IncompleteIcon
            }
            alt=""
            onClick={() => this.props.updateCandidateTask(task, 'put')}
            data-testid={ATSCandidateTaskListTestIds.FULL_PROFILE_COMPLETE_ICON}
          />
          <div>
            <span
              data-testid={ATSCandidateTaskListTestIds.FULL_PROFILE_TASK_TITLE}
              className={task.status === taskStatus.complete ? 'strikethrough' : ''}
            >
              {task.universal_task.title}
            </span>
            {task.status === taskStatus.incomplete && (
              <span data-testid={ATSCandidateTaskListTestIds.FULL_PROFILE_TASK_DUE_DATE}>
                &nbsp; - due on {moment(task.due_date).format('M/D/YYYY')}{' '}
                {this.renderAssignedUsers(task)}
              </span>
            )}
            {task.status === taskStatus.complete &&
              task.completed_by &&
              task.completed_by_date &&
              this.renderCompletedBy(task)}
          </div>
        </div>
        {this.canDeleteIncompleteTask(task) && (
          <DeleteButton
            sx={{ padding: '0' }}
            onClick={this.handleDelete}
            dataTestId={ATSCandidateTaskListTestIds.DELETE_BUTTON}
          />
        )}
      </div>
    );
  }
}
